"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
function FlowBody(_a) {
    var content = _a.content, fpti = _a.fpti, cancelUrl = _a.cancelUrl, header = _a.header, isCloseXHidden = _a.isCloseXHidden, children = _a.children, transitionOutHandler = _a.transitionOutHandler;
    function handleClick(e) {
        window.history.go(-1);
    }
    var closeTag = cancelUrl ?
        React.createElement("a", { href: cancelUrl, className: 'vx_modal-dismiss_x', onClick: function () { return transitionOutHandler && transitionOutHandler(); } },
            React.createElement("span", { className: 'vx_a11yText' }, content.common.close))
        :
            React.createElement("a", { onClick: handleClick, className: 'vx_modal-dismiss_x' },
                React.createElement("span", { className: 'vx_a11yText' }, content.common.close));
    return (React.createElement("div", { className: 'vx_modal-wrapper' },
        !isCloseXHidden && closeTag,
        React.createElement("div", { className: 'vx_modal-content' },
            React.createElement("header", { className: 'vx_modal-header' }, header && header.__html ?
                React.createElement("h2", { id: 'js_modalHeader', className: 'vx_h2', dangerouslySetInnerHTML: header }) :
                React.createElement("h2", { id: 'js_modalHeader', className: 'vx_h2' }, header)),
            React.createElement("div", { className: 'vx_modal-body vx_blocks-for-mobile' }, children))));
}
var mapStateToProps = function (_a) {
    var content = _a.content, fpti = _a.fpti;
    return ({ content: content, fpti: fpti });
};
exports.default = react_redux_1.connect(mapStateToProps)(FlowBody);
